import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  template: `
    <router-outlet></router-outlet>
    <footer class="app-footer">
      <a href="https://www.srdi.net/" target="_blank" rel="noopener noreferrer">
        <img src="assets/srdi-logo.png" alt="SRDI Logo" class="footer-logo">
      </a>
    </footer>
  `
})
export class AppComponent {

}